import React, { useEffect, useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { useSelector } from 'react-redux';
import { employeeList, getEmployeePayroleList } from '../../Services/Operations/ProductAPI';

const SalaryReport = () => {
    const [allPayrollList,setAllPayrollList]=useState([])
    const [searchMonth,setSearchMonth]=useState(1)
    const [searchYear,setSearchYear]=useState(2026)
     const [employee, setEmployee] = useState([]);
     const[filterList,setFilterList]=useState([])

    const token = useSelector((state) => state.user.token);

    const handleGetPauroleList=async()=>{
      try {
        const response=await getEmployeePayroleList(token)
        console.log("payrole list : ",response);
        if(response.data.status==='success'){
          setAllPayrollList(response.data.data)
        }
        
      } catch (error) {
        console.log("error : ",error);
        
      }
    }
      const fetchEmployeeList = async () => {
          try {
            const response = await employeeList(token);
            setEmployee(response);
            console.log("employee",response);
            
          } catch (error) {
            console.error("Error:", error);
          }
        };

        const findEmp=(id)=>{
          let emp=employee.find(i=>i.id===id) 
          if(emp){
           return `${emp?.firstName} ${emp?.lastName}` 
          }
          return  "Unknown"
        }

        const filterPayrollByMonthYear = ( month, year) => {
          console.log( month, year);
          
  let filtered= allPayrollList.filter(item => {
    if (!item.recordMonth) return false;

    const date = new Date(item.recordMonth);
    const recordMonth = date.getMonth() + 1; // JS months are 0-based
    const recordYear = date.getFullYear();

    return recordMonth === Number(month) && recordYear === Number(year);
  });
  setFilterList(filtered)
  console.log("filtered",filtered);
  

};

    useEffect(() => {
     handleGetPauroleList()
     fetchEmployeeList()
    }, [])

    useEffect(() => {
      filterPayrollByMonthYear(searchMonth,searchYear)
      
    }, [allPayrollList])
    
  return (
        <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="profit-loss-container">
          <h2 style={{fontSize:"40px",fontWeight:"600"}}>Salary Report</h2>
          {/* <div className="date-picker">
            <label>Select Date</label>
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
            >
              <option>March 6, 2025 - April 4, 2025</option>
              <option>Feb 1, 2025 - March 1, 2025</option>
            </select>
          </div> */}

          <div className="profit-summary" style={{display:"flex",justifyContent:"space-around",gap:"20px",padding:"20px"}}>
            <select
            style={{outline:"none",fontSize:"20px"}}
            value={searchMonth}
            name='month'
            onChange={(e)=>{setSearchMonth(e.target.value);filterPayrollByMonthYear(e.target.value,searchYear)}}>
              <option
              value={0}>Select Month</option>
              <option value={1}>January</option>
              <option value={2}>February</option>
              <option value={3}>March</option>
              <option value={4}>April</option>
              <option value={5}>May</option>
              <option value={6}>June</option>
              <option value={7}>July</option>
              <option value={8}>August</option>
              <option value={9}>September</option>
              <option value={10}>October</option>
              <option value={11}>November</option>
              <option value={12}>December</option>
            </select>

            <select
            style={{outline:"none",fontSize:"20px"}}
            value={searchYear}
            name='year'
            onChange={(e)=>{setSearchYear(e.target.value);filterPayrollByMonthYear(searchMonth,e.target.value)}}>
              <option>Select Year</option>
              <option value={2026}>2026</option>
              <option value={2025}>2025</option>
              <option value={2024}>2024</option>
              <option value={2023}>2023</option>
              <option value={2022}>2022</option>
            </select>
          </div>

          <div className="report-sections"
          style={{display:"flex",width:"100%",gap:"10px",margin:"15px"}}>
            <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                        <thead>
                          <tr style={{fontSize:"18px"}}>
                            <th style={{textAlign:"center"}}>Id</th>
                            <th style={{textAlign:"center"}}>Employee</th>
                            <th style={{textAlign:"center"}}>ctc</th>
                            <th style={{textAlign:"center"}}>paymentAmount</th>
                            <th style={{textAlign:"center"}}>grossSalary</th>
                            <th style={{textAlign:"center"}}>finalPaymentAmount</th>
                            <th style={{textAlign:"center"}}>leaves</th>
                            <th style={{textAlign:"center"}}>totalDaForMonth</th>
                            <th style={{textAlign:"center"}}>recordMonth</th>
                          </tr>
                        </thead>
                         {
                          filterList.length>0?
                         <tbody>
                           {filterList.map((item,ind)=>(
                              <tr key={ind}>
                            <td>{ind+1}</td>
                             <td>{findEmp(item.employeeId)}</td>
                              <td>{item.ctc}</td>
                               <td>{item.paymentAmount}</td>
                                <td>{item.grossSalary}</td>
                                 <td>{item.finalPaymentAmount}</td>
                                <td>{item.leaves}</td>
                                <td>{item.totalDaForMonth}</td>
                                <td>{item.recordMonth}</td>

                          </tr>
                            ))}
                          
                         </tbody>

                            :
                            <p style={{fontSize:"26px",fontWeight:"600",width:"100%",padding:"20px"}}>
                              No Track data for these filters</p>
                              }

                        </table>
                        </div>
                        </div>
                        </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SalaryReport
